<template>
  <v-card class="mb-4" outlined style="border-radius: 16px">
    <v-card-title>
      <app-icon color="primary" class="mr-3">auto_awesome</app-icon>
      Recursos inteligentes
    </v-card-title>
    <v-card-text>
      <div
        v-for="feature in features"
        :key="feature.title"
        class="feature-item pa-3 mb-3 d-flex"
        :class="{ 'feature-clickable': unlocked }"
        @click="open(feature)"
      >
        <v-avatar color="#EDEAFC" size="38" class="mr-3">
          <app-icon color="primary" small>{{ feature.icon }}</app-icon>
        </v-avatar>
        <div>
          <div class="d-flex align-center">
            <span class="font-weight-bold">{{ feature.title }}</span>
            <app-icon v-if="!unlocked" small class="ml-2" color="grey lighten-1">
              lock
            </app-icon>
          </div>
          <div class="text-caption text--secondary">
            {{ feature.description }}
          </div>
          <v-chip
            v-if="!unlocked"
            x-small
            class="mt-2"
            color="#F1EDFB"
            text-color="primary"
          >
            Disponível após cadastrar {{ customerAlias }}
          </v-chip>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { customerAlias } from "@/utils/customerAlias";
import { smartFeatures } from "@/components/dashboard/data/smartFeatures";

export default {
  data() {
    return {
      features: smartFeatures,
    };
  },

  computed: {
    customerAlias() {
      return customerAlias();
    },

    unlocked() {
      return this.$store.state.onboarding.hasCustomer;
    },
  },

  methods: {
    open(feature) {
      if (!this.unlocked) {
        return;
      }

      this.$router.push(feature.route);
    },
  },
};
</script>

<style scoped>
.feature-item {
  border: 1px solid #eeebf6;
  border-radius: 12px;
}

.feature-clickable {
  cursor: pointer;
}

.feature-clickable:hover {
  background: #f8f6fd;
}
</style>
